module.exports = __webpack_public_path__ + "static/media/study 201021.e2664d8f.png";